import { Lock } from 'lucide-react'
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

/**
 * Reusable "log in to continue" popup for gated features.
 *
 * Drop this in anywhere a feature should be visible but locked for signed-out
 * users: render it with your own `open` state, pass the feature's `title` and
 * `description`, and a `loginHref`. It is intentionally presentational so any
 * gated entry point (dialogs, buttons, menu items) can reuse it.
 */
export default function FeatureLockDialog({
  open,
  onOpenChange,
  title = 'Log in to use this feature',
  description = 'This feature is available to signed-in users.',
  loginHref = null,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <div className="flex flex-col items-center gap-4 py-2 text-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-muted text-muted-foreground">
            <Lock className="h-5 w-5" />
          </div>
          <div className="space-y-1.5">
            <DialogTitle className="text-lg">{title}</DialogTitle>
            <DialogDescription className="text-sm">{description}</DialogDescription>
          </div>
          <div className="mt-2 flex w-full flex-col gap-2 sm:flex-row sm:justify-center">
            {loginHref && (
              <Button asChild size="lg" className="w-full sm:w-auto">
                <a href={loginHref}>Log in</a>
              </Button>
            )}
            <Button
              variant="outline"
              size="lg"
              className="w-full sm:w-auto"
              onClick={() => onOpenChange(false)}
            >
              Maybe later
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
